/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneProcedureSimulationsRoute extends Route {
  templateName = 'apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations';

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneProcedureSimulationsRoute, {
  overrideRenderTemplate: false,
});
